import React from 'react';
import { Bot, Brain, Database, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const Services = () => {
  const services = [
    {
      icon: <Bot className="w-12 h-12 text-blue-600" />,
      title: 'AI Чат-бот для продаж',
      description: 'Умный ассистент, который консультирует, отвечает на вопросы, обрабатывает возражения и закрывает сделки. Работает 24/7 без выходных и больничных.',
      features: ['Продает и консультирует', 'Понимает контекст диалога', 'Работает в любых мессенджерах', 'Передает сложные запросы вам']
    },
    {
      icon: <Brain className="w-12 h-12 text-blue-600" />,
      title: 'Память и персонализация',
      description: 'Чат-бот запоминает каждого клиента: предпочтения, историю покупок, вопросы. Каждый диалог становится личным и релевантным.',
      features: ['Запоминает историю общения', 'Персональные предложения', 'Сегментация клиентов', 'Данные для аналитики']
    },
    {
      icon: <Database className="w-12 h-12 text-blue-600" />,
      title: 'Умные рассылки на автомате',
      description: 'На основе действий клиента автоматически запускаются триггерные рассылки: напоминания, спецпредложения, возвраты брошенных корзин.',
      features: ['Триггерные сценарии', 'Персонализация контента', 'Email, SMS, мессенджеры', 'Аналитика эффективности']
    },
    {
      icon: <TrendingUp className="w-12 h-12 text-blue-600" />,
      title: 'Интеграция с вашей CRM',
      description: 'Все данные о клиентах автоматически синхронизируются с вашей системой. Полный контроль над воронкой продаж в режиме реального времени.',
      features: ['Автосбор лидов', 'Синхронизация данных', 'Управление сделками', 'Отчеты и метрики']
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Полный цикл автоматизации продаж
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            От первого касания до повторных продаж — всё на автопилоте
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-blue-200 bg-white"
            >
              <CardHeader>
                <div className="mb-4 transform group-hover:scale-110 transition-transform duration-300">
                  {service.icon}
                </div>
                <CardTitle className="text-2xl font-bold text-gray-900 mb-2">
                  {service.title}
                </CardTitle>
                <CardDescription className="text-base text-gray-600">
                  {service.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <span className="w-2 h-2 bg-blue-600 rounded-full mr-3"></span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
